import React, { useEffect } from 'react';
import './ContactSuccessPopUp.module.scss';

export const ContactSuccessPopUp = ({
  onClose,
  title,
  subtitle,
  btnText
}) => {
  
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="card-success-pop-up success">
      <div className="header col">
        <div className="header-action">
          <img className="image-left" src="/static/images/icons/check-green.svg" alt="success" />
          <button className="close" onClick={onClose}>✕</button>
        </div>
        <div className="header-title col">
          {title && <h3>{title}</h3>}
          {subtitle && <h3>{subtitle}</h3>}
        </div>
      </div>
      <div className="content">
        <button className="option danger" onClick={onClose}>
          {btnText || "Oke"}
        </button>
      </div>
    </div>
  );
};
